export default __webpack_public_path__ + "static/media/Group-146TataNeu@2x.a5231b1e.png";